import Vue from 'vue'
import NProgress from 'nprogress'

NProgress.configure({ showSpinner: false, speed: 500 });

Vue.use(NProgress)